import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { AddressListing } from './AddressListing';

export const AddressButton = ({ address, clickHandler, isSelected }) => (
    <button
        value={address.hashKey}
        type="button"
        className={classnames({ 'address-button': true, selected: isSelected })}
        onClick={() => clickHandler(address)}
    >
        <div className="address-listing">
            <AddressListing
                fullName={address.fullName}
                firstName={address.firstName}
                lastName={address.lastName}
                street1={address.street1}
                street2={address.street2}
                city={address.city}
                state={address.state}
                postalCode={address.postalCode}
            />
        </div>
    </button>
);

AddressButton.defaultProps = {
    clickHandler: () => {},
    isSelected: false
};

AddressButton.propTypes = {
    address: PropTypes.shape({
        hashKey: PropTypes.string.isRequired,
        fullName: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        street1: PropTypes.string.isRequired,
        street2: PropTypes.string,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        postalCode: PropTypes.string.isRequired
    }).isRequired,
    clickHandler: PropTypes.func,
    isSelected: PropTypes.bool
};
